import { chakra, Flex, Box, Text } from "@chakra-ui/react";
import { colours } from "@shared/ui.design-system";

export const OrderSectionLine = chakra(Box, {
  baseStyle: {
    height: "1px",
    bgColor: colours.secondary.deep,
    mt: 2,
    mb: "-1"
  }
});

export const Container = chakra(Flex, {
  baseStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    mt: 1,
    alignItems: "flex-start !important"
  }
});

export const Label = chakra(Text, {
  baseStyle: {
    as: "span",
    mt: 0,
    flexGrow: 1
  }
});

export const DeliveryLabel = chakra(Text, {
  baseStyle: {
    as: "span",
    mt: 0
  }
});

export const PriceText = chakra(Text, {
  baseStyle: {
    as: "span",
    pl: -1,
    mt: 0,
    flexGrow: 0,
    textAlign: "right",
    whiteSpace: "nowrap"
  }
});
